/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * OSI.Core
 * OpenAPI spec version: v1
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ApiResponse,
  ApiResponseDbRegistrationAccountOSICoreTypes,
  ApiResponseInt32SystemPrivateCoreLib,
  RequestsAttachDocRequest,
  RequestsRegistrationAccountRequest,
  RequestsReuseDocRequest
} from '../models';

import { axiosForReactQueryInstance } from '../../reactQuery';
import type { ErrorType, BodyType } from '../../reactQuery';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Получить данные по счету
 */
export const getApiRegistrationAccountsId = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseDbRegistrationAccountOSICoreTypes>(
    { url: `/api/RegistrationAccounts/${id}`, method: 'GET', signal },
    options
  );
};

export const getGetApiRegistrationAccountsIdQueryKey = (id: number) => {
  return [`/api/RegistrationAccounts/${id}`] as const;
};

export const getGetApiRegistrationAccountsIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getApiRegistrationAccountsId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationAccountsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetApiRegistrationAccountsIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiRegistrationAccountsId>>> = ({ signal }) =>
    getApiRegistrationAccountsId(id, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getApiRegistrationAccountsId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetApiRegistrationAccountsIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getApiRegistrationAccountsId>>
>;
export type GetApiRegistrationAccountsIdQueryError = ErrorType<unknown>;

export function useGetApiRegistrationAccountsId<
  TData = Awaited<ReturnType<typeof getApiRegistrationAccountsId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationAccountsId>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationAccountsId>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationAccountsId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationAccountsId<
  TData = Awaited<ReturnType<typeof getApiRegistrationAccountsId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationAccountsId>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiRegistrationAccountsId>>,
          TError,
          Awaited<ReturnType<typeof getApiRegistrationAccountsId>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetApiRegistrationAccountsId<
  TData = Awaited<ReturnType<typeof getApiRegistrationAccountsId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationAccountsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Получить данные по счету
 */

export function useGetApiRegistrationAccountsId<
  TData = Awaited<ReturnType<typeof getApiRegistrationAccountsId>>,
  TError = ErrorType<unknown>
>(
  id: number,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiRegistrationAccountsId>>, TError, TData>>;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetApiRegistrationAccountsIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Изменить счет
 */
export const putApiRegistrationAccountsId = (
  id: number,
  requestsRegistrationAccountRequest: BodyType<RequestsRegistrationAccountRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    {
      url: `/api/RegistrationAccounts/${id}`,
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      data: requestsRegistrationAccountRequest
    },
    options
  );
};

export const getPutApiRegistrationAccountsIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putApiRegistrationAccountsId>>,
    TError,
    { id: number; data: BodyType<RequestsRegistrationAccountRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putApiRegistrationAccountsId>>,
  TError,
  { id: number; data: BodyType<RequestsRegistrationAccountRequest> },
  TContext
> => {
  const mutationKey = ['putApiRegistrationAccountsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putApiRegistrationAccountsId>>,
    { id: number; data: BodyType<RequestsRegistrationAccountRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return putApiRegistrationAccountsId(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutApiRegistrationAccountsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putApiRegistrationAccountsId>>
>;
export type PutApiRegistrationAccountsIdMutationBody = BodyType<RequestsRegistrationAccountRequest>;
export type PutApiRegistrationAccountsIdMutationError = ErrorType<unknown>;

/**
 * @summary Изменить счет
 */
export const usePutApiRegistrationAccountsId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putApiRegistrationAccountsId>>,
      TError,
      { id: number; data: BodyType<RequestsRegistrationAccountRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof putApiRegistrationAccountsId>>,
  TError,
  { id: number; data: BodyType<RequestsRegistrationAccountRequest> },
  TContext
> => {
  const mutationOptions = getPutApiRegistrationAccountsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Удаление счета
 */
export const deleteApiRegistrationAccountsId = (
  id: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>({ url: `/api/RegistrationAccounts/${id}`, method: 'DELETE' }, options);
};

export const getDeleteApiRegistrationAccountsIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiRegistrationAccountsId>>,
    TError,
    { id: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiRegistrationAccountsId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ['deleteApiRegistrationAccountsId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiRegistrationAccountsId>>, { id: number }> = (
    props
  ) => {
    const { id } = props ?? {};

    return deleteApiRegistrationAccountsId(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiRegistrationAccountsIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiRegistrationAccountsId>>
>;

export type DeleteApiRegistrationAccountsIdMutationError = ErrorType<unknown>;

/**
 * @summary Удаление счета
 */
export const useDeleteApiRegistrationAccountsId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiRegistrationAccountsId>>,
      TError,
      { id: number },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof deleteApiRegistrationAccountsId>>, TError, { id: number }, TContext> => {
  const mutationOptions = getDeleteApiRegistrationAccountsIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Добавить счет
 */
export const postApiRegistrationAccounts = (
  requestsRegistrationAccountRequest: BodyType<RequestsRegistrationAccountRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseDbRegistrationAccountOSICoreTypes>(
    {
      url: `/api/RegistrationAccounts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsRegistrationAccountRequest,
      signal
    },
    options
  );
};

export const getPostApiRegistrationAccountsMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiRegistrationAccounts>>,
    TError,
    { data: BodyType<RequestsRegistrationAccountRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiRegistrationAccounts>>,
  TError,
  { data: BodyType<RequestsRegistrationAccountRequest> },
  TContext
> => {
  const mutationKey = ['postApiRegistrationAccounts'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiRegistrationAccounts>>,
    { data: BodyType<RequestsRegistrationAccountRequest> }
  > = (props) => {
    const { data } = props ?? {};

    return postApiRegistrationAccounts(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiRegistrationAccountsMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiRegistrationAccounts>>
>;
export type PostApiRegistrationAccountsMutationBody = BodyType<RequestsRegistrationAccountRequest>;
export type PostApiRegistrationAccountsMutationError = ErrorType<unknown>;

/**
 * @summary Добавить счет
 */
export const usePostApiRegistrationAccounts = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiRegistrationAccounts>>,
      TError,
      { data: BodyType<RequestsRegistrationAccountRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiRegistrationAccounts>>,
  TError,
  { data: BodyType<RequestsRegistrationAccountRequest> },
  TContext
> => {
  const mutationOptions = getPostApiRegistrationAccountsMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Загрузить скан реквизитов к счёту заявки (DocTypeCode = "IBAN_INFO").
Возвращает Id нового RegistrationDoc.
 */
export const postApiRegistrationAccountsIdDoc = (
  id: number,
  requestsAttachDocRequest: BodyType<RequestsAttachDocRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseInt32SystemPrivateCoreLib>(
    {
      url: `/api/RegistrationAccounts/${id}/doc`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsAttachDocRequest,
      signal
    },
    options
  );
};

export const getPostApiRegistrationAccountsIdDocMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiRegistrationAccountsIdDoc>>,
    TError,
    { id: number; data: BodyType<RequestsAttachDocRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiRegistrationAccountsIdDoc>>,
  TError,
  { id: number; data: BodyType<RequestsAttachDocRequest> },
  TContext
> => {
  const mutationKey = ['postApiRegistrationAccountsIdDoc'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiRegistrationAccountsIdDoc>>,
    { id: number; data: BodyType<RequestsAttachDocRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return postApiRegistrationAccountsIdDoc(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiRegistrationAccountsIdDocMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiRegistrationAccountsIdDoc>>
>;
export type PostApiRegistrationAccountsIdDocMutationBody = BodyType<RequestsAttachDocRequest>;
export type PostApiRegistrationAccountsIdDocMutationError = ErrorType<unknown>;

/**
 * @summary Загрузить скан реквизитов к счёту заявки (DocTypeCode = "IBAN_INFO").
Возвращает Id нового RegistrationDoc.
 */
export const usePostApiRegistrationAccountsIdDoc = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiRegistrationAccountsIdDoc>>,
      TError,
      { id: number; data: BodyType<RequestsAttachDocRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiRegistrationAccountsIdDoc>>,
  TError,
  { id: number; data: BodyType<RequestsAttachDocRequest> },
  TContext
> => {
  const mutationOptions = getPostApiRegistrationAccountsIdDocMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Удалить скан реквизитов у счёта заявки.
Физический Scan удаляется только если нет других RegistrationDoc, ссылающихся на него.
 */
export const deleteApiRegistrationAccountsIdDocDocId = (
  id: number,
  docId: number,
  options?: SecondParameter<typeof axiosForReactQueryInstance>
) => {
  return axiosForReactQueryInstance<ApiResponse>(
    { url: `/api/RegistrationAccounts/${id}/doc/${docId}`, method: 'DELETE' },
    options
  );
};

export const getDeleteApiRegistrationAccountsIdDocDocIdMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteApiRegistrationAccountsIdDocDocId>>,
    TError,
    { id: number; docId: number },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteApiRegistrationAccountsIdDocDocId>>,
  TError,
  { id: number; docId: number },
  TContext
> => {
  const mutationKey = ['deleteApiRegistrationAccountsIdDocDocId'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteApiRegistrationAccountsIdDocDocId>>,
    { id: number; docId: number }
  > = (props) => {
    const { id, docId } = props ?? {};

    return deleteApiRegistrationAccountsIdDocDocId(id, docId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteApiRegistrationAccountsIdDocDocIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteApiRegistrationAccountsIdDocDocId>>
>;

export type DeleteApiRegistrationAccountsIdDocDocIdMutationError = ErrorType<unknown>;

/**
 * @summary Удалить скан реквизитов у счёта заявки.
Физический Scan удаляется только если нет других RegistrationDoc, ссылающихся на него.
 */
export const useDeleteApiRegistrationAccountsIdDocDocId = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteApiRegistrationAccountsIdDocDocId>>,
      TError,
      { id: number; docId: number },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteApiRegistrationAccountsIdDocDocId>>,
  TError,
  { id: number; docId: number },
  TContext
> => {
  const mutationOptions = getDeleteApiRegistrationAccountsIdDocDocIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Переиспользовать скан реквизитов другого счёта заявки.
Создаётся новый RegistrationDoc с тем же ScanId (файл не дублируется).
Возвращает Id нового RegistrationDoc.
 */
export const postApiRegistrationAccountsIdDocReuse = (
  id: number,
  requestsReuseDocRequest: BodyType<RequestsReuseDocRequest>,
  options?: SecondParameter<typeof axiosForReactQueryInstance>,
  signal?: AbortSignal
) => {
  return axiosForReactQueryInstance<ApiResponseInt32SystemPrivateCoreLib>(
    {
      url: `/api/RegistrationAccounts/${id}/doc/reuse`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: requestsReuseDocRequest,
      signal
    },
    options
  );
};

export const getPostApiRegistrationAccountsIdDocReuseMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postApiRegistrationAccountsIdDocReuse>>,
    TError,
    { id: number; data: BodyType<RequestsReuseDocRequest> },
    TContext
  >;
  request?: SecondParameter<typeof axiosForReactQueryInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postApiRegistrationAccountsIdDocReuse>>,
  TError,
  { id: number; data: BodyType<RequestsReuseDocRequest> },
  TContext
> => {
  const mutationKey = ['postApiRegistrationAccountsIdDocReuse'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postApiRegistrationAccountsIdDocReuse>>,
    { id: number; data: BodyType<RequestsReuseDocRequest> }
  > = (props) => {
    const { id, data } = props ?? {};

    return postApiRegistrationAccountsIdDocReuse(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostApiRegistrationAccountsIdDocReuseMutationResult = NonNullable<
  Awaited<ReturnType<typeof postApiRegistrationAccountsIdDocReuse>>
>;
export type PostApiRegistrationAccountsIdDocReuseMutationBody = BodyType<RequestsReuseDocRequest>;
export type PostApiRegistrationAccountsIdDocReuseMutationError = ErrorType<unknown>;

/**
 * @summary Переиспользовать скан реквизитов другого счёта заявки.
Создаётся новый RegistrationDoc с тем же ScanId (файл не дублируется).
Возвращает Id нового RegistrationDoc.
 */
export const usePostApiRegistrationAccountsIdDocReuse = <TError = ErrorType<unknown>, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postApiRegistrationAccountsIdDocReuse>>,
      TError,
      { id: number; data: BodyType<RequestsReuseDocRequest> },
      TContext
    >;
    request?: SecondParameter<typeof axiosForReactQueryInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof postApiRegistrationAccountsIdDocReuse>>,
  TError,
  { id: number; data: BodyType<RequestsReuseDocRequest> },
  TContext
> => {
  const mutationOptions = getPostApiRegistrationAccountsIdDocReuseMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
